module.exports = __webpack_public_path__ + "media/images/agent-f8f6966ce9d2e7608127e83eba1eb51c.svg";